import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function WhyItFailed() {
  const reasons = ['La lavandina y el amoníaco contienen componentes que le dicen al gato "orina aquí de nuevo" para reforzar su olor.', 'Los gritos y castigos elevan el cortisol del gato, haciendo que marque MÁS para sentirse seguro en su territorio.', 'Las arenas perfumadas huelen bien para vos, pero son una explosión química insoportable para el olfato superior de tu gato.', 'Limpiar "por encima" no elimina el ácido úrico, que queda como un faro de neón invisible para los ojos humanos.'];
  return <section className="w-full bg-white py-6 md:py-20 px-4 md:px-6" data-id="element-472">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-473">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-5 md:mb-8 text-center" data-id="element-474">
          Por qué todo lo que probaste falló:
        </h2>

        <div className="space-y-3" data-id="element-475">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-3" data-id="element-476">
              <XCircleIcon className="w-5 h-5 text-[#8B4513] flex-shrink-0 mt-1" data-id="element-477" />
              <p className="text-[#1C1C1C] text-lg" data-id="element-478">{reason}</p>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}